export default{ // 运行在 评估师APP-复检工单列表-检测报告
  tabs: [
    {
      name: 'CheckReport',
      path: '/checkReport',
      component: () => import('./src/CheckReport.vue'),
      meta: {
        title: '检测报告'
      }
    },
    {
      name: 'ShareCheckReport',
      path: '/shareCheckReport',
      component: () => import('./src/CheckReport.vue'),
      meta: {
        title: '检测报告'
      }
    },

    // 支持按版本查询的检测报告、及分享
    {
      name: 'CheckReportSupportVersion',
      path: '/checkReportSupportVersion',
      component: () => import('./src/CheckReportSupportVersion.vue'),
      meta: {
        title: '检测报告'
      }
    },
    {
      name: 'ShareCheckReportSupportVersion',
      path: '/shareCheckReportSupportVersion',
      component: () => import('./src/CheckReportSupportVersion.vue'),
      meta: {
        title: '检测报告'
      }
    },

  ]
}
